<template>
  <b-form-row>
    <b-modal
      size="xl"
      button-size="sm"
      ref="finder"
      hide-footer
      :id="this.id"
      :title="title"
    >
      <PaisList :prefix="updatedPrefix" :codEmpresa="codEmpresa" @onDblClickPais="paisSelect" />
    </b-modal>

    <lg-form-input-finder
      :value="computedValue"
      @input="updateValue"
      fieldDescription="descricao"
      label="País: *"
      invalidFeedback="País deve ser informado!"
      description=""
      @handleClean="handleClean"
    >
      <template #prepend>
        <b-button
          @click="show"
          class="btn-input-finder"
          pressed
        >
          <b-icon icon="search" />
        </b-button>
      </template>
    </lg-form-input-finder>
  </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
import PaisList from "../../modules/cadastros/pais/PaisList.vue";

export default {
  components: { LgFormInputFinder, PaisList },
  props: {
    id: String,
    prefix: Array,
    codEmpresa: Number,
    value: Object,
  },
  data() {
    return {
      internalValue: this.value || {},
    };
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue;
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.internalValue;
      },
      set(newValue) {
        this.internalValue = newValue;
      },
    },
    updatedPrefix() {
      return [...this.prefix, "País"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
  },
  methods: {
    show() {
      this.$bvModal.show(this.id);
    },
    updateValue(newValue) {
      this.computedValue = newValue;
      this.$emit('input', newValue);
    },
    handleClean() {
      this.computedValue = {};
      this.$emit('input', {});
    },
    paisSelect(item) {
      this.computedValue = item;
      this.$emit('input', item);
      this.$bvModal.hide(this.id);
    },
  },
};
</script>
